import { Checkbox } from "../../ui/checkbox.js";

export interface PublishedPolicy {
  kind: string; typeName: string; title: string; version: string;
  /** Every employee signs it: always required, not HR's choice. */
  signAll: boolean;
}

// The policy documents this new hire must sign during onboarding, ticked on
// the create form (all published ones start ticked). Saved with the hire;
// HR can still change them later on the profile. Only ticked documents appear
// in step 8; a document every employee signs that is left unticked is signed
// in the login pop-up after the hire starts using the app.
export function NewHirePolicyPicker({ options, selected, onChange }: {
  options: PublishedPolicy[];
  selected: string[];
  onChange: (kinds: string[]) => void;
}) {
  const toggle = (kind: string, on: boolean) =>
    onChange(on ? [...selected, kind] : selected.filter(k => k !== kind));

  return (
    <div className="mt-4 rounded-md border border-surface-200 bg-surface-50 px-3.5 py-3">
      <div className="text-[13px] font-semibold">Documents to sign</div>
      <p className="mb-2 text-[11px] text-surface-500">The employee reads and signs these on the last step of the onboarding link. Ticked ones are required.</p>
      {options.length === 0 ? (
        <p className="text-xs text-surface-500">No policy document is published yet. Add one in Admin → Policy Documents.</p>
      ) : (
        <ul className="grid gap-1.5 sm:grid-cols-2">
          {options.map(o => {
            const id = `new-hire-policy-${o.kind}`;
            return (
              <li key={o.kind} className="flex items-center gap-2">
                <Checkbox id={id} checked={selected.includes(o.kind)} onCheckedChange={(v) => toggle(o.kind, v === true)} />
                <label htmlFor={id} className="text-xs text-surface-700">
                  {o.typeName} <span className="text-surface-400">· {o.title} v{o.version}{o.signAll && " · all employees sign it at login"}</span>
                </label>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
